import { render, staticRenderFns } from "./Bids.vue?vue&type=template&id=54c3ab4c&"
import script from "./Bids.vue?vue&type=script&lang=js&"
export * from "./Bids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports